import { TERMS_OF_USE_LATEST_VERSION } from "_constants/GlobalConstants";
import { TERMS_OF_USE_PATHNAME } from "_constants/PageRoutes";

export const TermsOfUseHelper = {
    GetTouPath
}
function GetTouPath(user, pathnames) {
    let touVersion = '';
    let touRegion = '';
    if (pathnames[pathnames.length - 1] === TERMS_OF_USE_PATHNAME) {
        // Get Latest Tou for current user
        touVersion = TERMS_OF_USE_LATEST_VERSION;
        touRegion = 'us';
        if (user.organization && user.organization.touRegionHtm) {
            touRegion = user.organization.touRegionHtm;
        }
    } else {
        // Get Tou Path by pathnames
        touVersion = pathnames[pathnames.length - 2];
        touRegion = pathnames[pathnames.length - 1];
    }

    return `/tou/${touVersion}/tou_${touRegion}.htm`;
}
